import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    formaPago: { label: i18n.t('tipos.metadata.pago'), value: '' },
    nombreCuenta: { label: i18n.t('invoices.invoices_issuing.nombre_cuenta'), value: '' },
    iban: { label: i18n.t('invoices.invoices_issuing.iban'), value: '' },
    bicSwift: { label: i18n.t('invoices.invoices_issuing.bic_swift'), value: '' },
    fecha: { label: i18n.t('invoices.invoices_issuing.fecha_mandato'), value: '' },
  } 
}
const getTranslateColumns = () => [
  {
    field: ' ',
    title: '',
    width: '100px',
    headerCell: (h) => h('span'),
    cell: 'actionsTemplate',
    locked: true,
    lockable: false,
    columnMenu: false,
    reorderable: false,
    filterable: false,
    resizable: false,
    groupable: false,
    only: { empty: false },
    extraparams: {
      actions: [
        // { idAccion: 2, label: i18n.t('app.edit'), icon: 'editpencil' },
        { idAccion: 3, label: i18n.t('app.remove'), icon: 'trash' }
      ]
    } 
  },
  { field: 'uuid', title: 'UUID', columnMenu: 'myTemplate', width: '300px', locked: false, hidden: true, only: { roles: [3] } },
  { field: 'formaPago', title: i18n.t('invoices.invoices_issuing.step6.header'), format: 'FORMAS_DE_PAGO', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '170px', locked: false },
  { field: 'nombreCuenta', title: i18n.t('invoices.invoices_issuing.nombre_cuenta'), columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'iban', title: i18n.t('invoices.invoices_issuing.iban'), hidden: false, columnMenu: 'myTemplate', width: '200px', locked: false },
  { field: 'bicSwift', title: i18n.t('invoices.invoices_issuing.bic_swift'), hidden: false, columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'fecha', title: i18n.t('invoices.invoices_issuing.fecha_mandato'), hidden: false, columnMenu: 'myTemplate', width: '200px', locked: false },
]
const getDefaultForm = () => ({
  paymentMethod: { 
    formaPago: '',
    toBeCredit: true,
    iban: '',
    bicSwift: '',
    fecha: '',
    tipoAuth: 0,
  }
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const customState = getDefaultState()
const customGetters = { form: state => state.form }
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
const mystore = parent({ getTranslateColumns, customState, customGetters, customActions, selectable: true, navigate: false, namespaced: true, getTranslateMasterFilters })

export default mystore
